import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/SideBar.css';
import {
  FaUsers,
  FaRegCopy,
  FaEnvelopeOpenText,
  FaEnvelope,
  FaLinkedin,
  FaWhatsapp,
  FaCalendarAlt,
  FaPhoneAlt,
  FaTachometerAlt, FaFacebookF, FaInstagram, FaSignal, FaCogs, FaUser, FaLock, FaPhone
} from 'react-icons/fa';
import { SiMeta } from 'react-icons/si';
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";  // Ant Design
// import logo from '../../images/logo.png';

function SideBar({ isOpen }) {
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation(); // to detect active route

  const handleToggle = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    if (
      location.pathname.startsWith("/templates") ||
      location.pathname.startsWith("/email-campaign")
    ) {
      setOpenMenu("email");
    }
    if (
      location.pathname.startsWith("/linkedin-campaign")
    ) {
      setOpenMenu("linkedin");
    }
    if (
      location.pathname.startsWith("/whatsapp-templates") ||
      location.pathname.startsWith("/whatsapp-campaign")
    ) {
      setOpenMenu("whatsapp");
    }
  }, [location.pathname]);

  return (
    <nav className={`sidebar-wrapper shadow-md ${isOpen ? 'show' : 'hide'}`}>
      <div className="sidebar-inner d-flex flex-column">

        {/* 1. Logo Section */}
        <div className="sidebar-logo p-3">
          <img src="/images/logo.jpg" alt="Logo" className="img-fluid" />
        </div>

        {/* 2. Menu Section */}
        <div className="sidebar-menu flex-grow-1 overflow-auto px-3">
          <ul className="list-unstyled mt-3">

            <li>
              <a
                href="/user-dashboard"
                className={`text-decoration-none d-block py-2 ${isActive('/user-dashboard') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
                Dashboard
              </a>
            </li>
            <li>
              <a
                href="/view-pricing"
                className={`text-decoration-none d-block py-2 ${isActive('/view-pricing') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
                Live Coins Pricing
              </a>
            </li>
            <li>
              <a
                href="/add-funds"
                className={`text-decoration-none d-block py-2 ${isActive('/add-funds') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
                Add Funds
              </a>
            </li>
            <li>
              <a
                href="/add-coins"
                className={`text-decoration-none d-block py-2 ${isActive('/add-coins') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
                Buy Coins
              </a>
            </li>
            <li>
              <a
                href="/widthdraw"
                className={`text-decoration-none d-block py-2 ${isActive('/widthdraw') ? 'active-link' : 'text-dark'}`}
              >
                <FaTachometerAlt className="me-2" />
                Widthdraw
              </a>
            </li>
            <li>
              <a
                href="https://theblackstone.org.in/images/TermsandConditions.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none d-block py-2 text-dark"
              >
                <FaTachometerAlt className="me-2" />
                Terms & Conditions
              </a>
            </li>
          </ul>
        </div>

        {/* 3. Footer */}
        <div className="sidebar-footer p-3 text-center text-muted small">
          © 2025 Blackstone
        </div>
      </div>
    </nav>
  );
}

export default SideBar;
